import { render, staticRenderFns } from "./TaskAdd.vue?vue&type=template&id=b145b778&scoped=true"
import script from "./TaskAdd.vue?vue&type=script&lang=js"
export * from "./TaskAdd.vue?vue&type=script&lang=js"
import style0 from "./TaskAdd.vue?vue&type=style&index=0&id=b145b778&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b145b778",
  null
  
)

export default component.exports